<div class="card">
    <div class="card-header">
        Confirm Employee 
    </div>
    <div class="card-body">
        <div class="row mt-2">
            <ul class="list-group">
                <li class="list-group-item">
                    <div class="row">
                        <div class="col-4">{{data.Empcode}} </div>
                        <div class="col">{{data.EmployeeName}}</div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-outline-primary" name="cancel" (click)="closeModal(false)" ><i class="bi bi-x-lg"></i>Cancel
                </button>
             &nbsp;  <button class="btn btn-sm btn-primary" name="ok" (click)="closeModal(true)"> <i class="bi bi-plus"> </i> Add </button>
      
            </div>
        </div>
    </div>
</div>